export const meal_filters = [
  {
    label: 'Tag Availability',
    type: 'availability',
    children: [
      {
        label: 'All Meals',
        value: ''
      },
      {
        label: 'Meal with tags',
        value: true
      }
    ]
  },
  {
    label: 'Field',
    type: 'field',
    children: [
      {
        label: 'All',
        value: ''
      },
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Date Created',
        value: 'created_at'
      },
      {
        label: 'Date Modified',
        value: 'updated_at'
      }
    ]
  },
  {
    label: 'Sort By',
    type: 'sort',
    children: [
      {
        label: 'Ascending',
        value: 'asc'
      },
      {
        label: 'Descending',
        value: 'desc'
      }
    ]
  },
  {
    label: 'Status',
    type: 'status',
    children: [
      {
        label: 'All',
        value: 'null'
      },
      {
        label: 'Hidden Only',
        value: true
      },
      {
        label: 'Visible Only',
        value: false
      }
    ]
  },
  {
    label: 'Type',
    type: 'type',
    children: [
      {
        label: 'All',
        value: ''
      },
      {
        label: 'Breakfast',
        value: 'Breakfast'
      },
      {
        label: 'Lunch',
        value: 'Lunch'
      },
      {
        label: 'Dinner',
        value: 'Dinner'
      }
    ]
  }
];
